import { Icon } from "@iconify/react";
import React from "react";

export const ChatList = ({ handleChats, sendersList, isLoading }) => {
  return (
    <div className="chatList">
      <h5 className="mb-3">
        <span>Messages</span>
        {/* <span className='lable_new'>3 new</span> */}
      </h5>
      {sendersList &&
        sendersList.map((item, index) => (
          <div key={index}>
            <div
              className="chat_in"
              onClick={() =>
                handleChats(
                  item.msg_rec_userprofile_id,
                  item.msg_rec_name,
                  item.user_photo_url
                )
              }
            >
              {item.user_photo_url ? (
                <img
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                  src={item.user_photo_url}
                  alt=""
                />
              ) : (
                <Icon icon="carbon:user-avatar-filled" className="w-8 h-8" />
              )}

              <div className="details">
                <h5 className="mb-0">{item.msg_rec_name}</h5>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};
